import { AfterViewInit, Component, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsSunburst from 'highcharts/modules/sunburst';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment';
declare let $: any;
import * as CryptoJS from 'crypto-js';
import { Buffer } from 'buffer';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { CustomServiceService } from '../../service/custom-service.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
// HighchartsMore(Highcharts);
// HighchartsSolidGauge(Highcharts);
// HighchartsSunburst(Highcharts);

@Component({
  selector: 'app-farmers-banefited',
  templateUrl: './farmers-banefited.component.html',
  styleUrls: ['./farmers-banefited.component.css'],
})
export class FarmersBanefitedComponent implements AfterViewInit {
  cselectedYear: any = '';
  cselectedState: any = '';
  selectedYear: any = '';
  selectedState: any = '';
  ShowTabView: boolean = false;
  january: any = '';
  february: any = '';
  march: any = '';
  april: any = '';
  may: any = '';
  june: any = '';
  july: any = '';
  august: any = '';
  september: any = '';
  october: any = '';
  november: any = '';
  december: any = '';
  totalCount: any = '';
  farmerStateUTList: any;


  Toggle(boolean: boolean){
    this.ShowTabView = boolean;
    $('.Toggle').removeClass('active');
    if(boolean){
      $('#farmerchart').addClass('active');
    } else {
      $('#farmertbl').addClass('active');
    }
  }

  public ngAfterViewInit(): void {
    // this.getFarmerStateUTList();
    // this.createChartColumn();
  }
  private getRandomNumber(min: number, max: number, total: number): number {
    return Math.floor(total);
  }

  constructor(
    private fciwebservice: fciWebsiteService,
    private routerparam: ActivatedRoute,
    private router: ActivatedRoute,
    private encDec: EncryptDecryptService,
    private route: Router,
    private httpservice: CustomServiceService,
    public translate: TranslateService
  ) {
    //code
  }
  start: number = 0;
  limit: number = 10;
  currentPage: number = 1;
  totalRecords: number = 0;
  ProcwheatData: any = [];
  financialYears: any = [];
  language:any = sessionStorage.getItem('locale');
  ngOnInit(): void {
    this.start = (this.currentPage - 1) * this.limit;
    this.getFarmerStateUTList();
    this.selectedYear = this.getCurrentFinancialYear();
    this.cselectedYear = this.getCurrentFinancialYear();    
    this.getFarmerProcListing('', this.selectedYear, this.start, this.limit, this.currentPage);
    this.createChartColumn('',this.cselectedYear);
    this.yearlist();    
  
  }

  getCurrentFinancialYear(): string {
    const currentDate = new Date();
    const financialYearStart = new Date(currentDate.getFullYear(), 3, 1); // Assuming a financial year starting on April 1

    if (currentDate < financialYearStart) {
      return `${currentDate.getFullYear() - 1}-${currentDate.getFullYear()}`;
    } else {
      return `${currentDate.getFullYear()}-${currentDate.getFullYear() + 1}`;
    }
  }

  content_apiresponse: any;

  apirespons: any;
  ProcfarmerData: any = [];

  getFarmerProcListing(
    selectedState: any,
    selectedYear: any,
    start: number,
    limit: number,
    currentPage: number
  ) {
    let param = {
      selectedState: selectedState,
      selectedYear: selectedYear,
    };
    this.fciwebservice
      .getFarmerProcListing(param)
      .subscribe((response: any) => {
        switch (response.type) {
          case HttpEventType.Sent:
            //console.log('Sent' + HttpEventType.Sent);
            break;
          case HttpEventType.ResponseHeader:
            //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
            break;
          case HttpEventType.UploadProgress:
            break;
          case HttpEventType.Response:
            this.apirespons = response.body;
            let respData = this.apirespons.RESPONSE_DATA;
            let respToken = this.apirespons.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(
              respData,
              environment.apiHashingKey
            ).toString();
            if (respToken == verifyToken) {
              let res = JSON.parse(Buffer.from(respData, 'base64').toString());
              this.ProcfarmerData = res.result;
              // console.log(this.ProcfarmerData);
              //  this.createChartColumn();
              if (res.result.length > 0) {
                this.totalRecords = res.result.length;
              } else {
                this.totalRecords = 0;
              }
            }
        }
      });
  }
  content_apiresponses: any;
  yearlist() {
    let param = {
      selectedYear: '',
    };
    this.httpservice
      .getFarmerBenefit(param, `api/getfarmerbenfityearlist`)
      .subscribe((response: any) => {
        this.content_apiresponses = response;
        let respData = this.content_apiresponses.RESPONSE_DATA;
        let respToken = this.content_apiresponses.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(
          respData,
          environment.apiHashingKey
        ).toString();
        if (respToken == verifyToken) {
          let response: any = Buffer.from(respData, 'base64');
          response = JSON.parse(response);
          if (response.status == 1) {
            this.financialYears = response.result;
          } else {
            Swal.fire({
              icon: 'error',
              text: response.messsage,
            });
          }
        }
      });
  }

  onYearSelected(): any {
    this.getFarmerProcListing(
      this.selectedState,
      this.selectedYear,
      this.start,
      this.limit,
      this.currentPage
    );
  }
  onStateSelected(): any {
    this.getFarmerProcListing(
      this.selectedState,
      this.selectedYear,
      this.start,
      this.limit,
      this.currentPage
    );
  }
  pageChanged(page: any) {
    let param_arr = [];
    let category, fyear;
    // category="";
    // fyear="";
    this.currentPage = page;
    this.totalRecords = 0;
    this.ProcfarmerData = [];
    this.start = (this.currentPage - 1) * this.limit;
    this.getFarmerProcListing(
      this.selectedState,
      this.selectedYear,
      this.start,
      this.limit,
      this.currentPage
    );
  }

  public getFarmerStateUTList() {
    let param = {};
    this.fciwebservice
      .getFarmerStateUTList(param)
      .subscribe((response: any) => {
        switch (response.type) {
          case HttpEventType.Sent:
            //console.log('Sent' + HttpEventType.Sent);
            break;
          case HttpEventType.ResponseHeader:
            //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
            break;
          case HttpEventType.UploadProgress:
            //this.evenTotal = response.total;
            //this.progress = Math.round(response.loaded / this.evenTotal * 100);
            break;
          case HttpEventType.Response:
            this.apirespons = response.body;
            let respData = this.apirespons.RESPONSE_DATA;
            let respToken = this.apirespons.RESPONSE_TOKEN;
            let verifyToken = CryptoJS.HmacSHA256(
              respData,
              environment.apiHashingKey
            ).toString();
            if (respToken == verifyToken) {
              let res = JSON.parse(Buffer.from(respData, 'base64').toString());
              this.farmerStateUTList = res.result;
            }
        }
      });
  }
  private getRandomDecimal(min: number, max: number, total: any): any {
    //   const randomValue = Math.random() * (max - min) + min;
    //   const validDecimalPlaces = Math.max(0, Math.min(total, 100));
    //   return parseFloat((total));
    // }
    // public mapFarmerDataToCategories(stockData: any[]): number[] {
    //   const categories: string[] = [];
    //   this.farmerStateUTList.forEach((item: { state_English: string; }) => {
    //     categories.push(item.state_English);
    //   });
    //   const amounts: number[] = [];
    //   for (const category of categories) {
    //     const stateData = stockData.find(item => item.state_English === category);
    //     if (stateData) {
    //       amounts.push(stateData.Total_farmers_Benefited);
    //     //amounts.push(parseFloat(stateData.total.toFixed(2)));
    //     } else {
    //       amounts.push(0);
    //     }
    //   }
    //   return amounts;
  }
  // stockAmount:any;

  conYearSelected(): any {
    this.createChartColumn(this.cselectedState, this.cselectedYear);
  }
  conStateSelected(): any {
    this.createChartColumn(this.cselectedState, this.cselectedYear);
  }

  public createChartColumn(selectedState: any, selectedYear: any) {
    // if(this.selectedState == ''){}
    // this.stockAmount = this.mapFarmerDataToCategories(this.ProcfarmerData);
    // let date = new Date();
    // const data: any[] = [];

    //   const categories: string[] = [];
    // this.farmerStateUTList.forEach((item: { state_English: string; }) => {
    //   categories.push(item.state_English);
    // });

    // for (let i = 0; i < categories.length; i++) {
    //   date.setDate(new Date().getDate() + i);
    //   data.push({
    //     name: `${date.getDate()}/${date.getMonth() + 1}`,
    //     // y: this.getRandomNumber(0, 10000, this.stockAmount[i]),
    //     // y:this.stockAmount[i],
    //      y: this.getRandomDecimal(1, 10, this.stockAmount[i]),
    //   });
    // }

    let param = {
      selectedState: selectedState,
      selectedYear: selectedYear,
    };
    this.fciwebservice
      .getFarmerData(param, 'api/getFarmerProcGraphListing')
      .subscribe((response: any) => {
        let apirespons: any = response;
        let respData = apirespons.RESPONSE_DATA;
        let respToken = apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(
          respData,
          environment.apiHashingKey
        ).toString();
        if (respToken == verifyToken) {
          let res: any = JSON.parse(Buffer.from(respData, 'base64').toString());
          if (res.status == 1) {
            const chart = Highcharts.chart(
              'chart-farmers' as any,
              {
                title: {
                  text: this.language === 'English' ? 'Farmer Benefit Procurement' : 'किसान लाभ खरीद'
                },
                chart: {
                  type: 'column',
                },
                credits: {
                  enabled: false,
                },
                legend: {
                  enabled: false,
                },

                yAxis: {
                  min: 0,
                  title: undefined,
                },
                xAxis: {
                  categories:this.language === 'English' ? res.xcategories : res.StateHn,
                },
                tooltip: {
                  headerFormat: '',
                  pointFormat: `<div>{series.name}: {point.y}</div>`,
                  shared: true,
                  useHTML: true,
                },
                plotOptions: {
                  column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                  },
                  // bar: {
                  //   dataLabels: {
                  //     enabled: true,
                  //   },
                  // },
                },
                series: [
                  {
                    name: 'Amount',
                    data: res.result,
                    color: '#006637',
                  },
                ],
              } as any
            );
          }
        }
      });
  }

  countDecimals: any = (value: any): any => {
    if (value % 1 != 0) return value.toString().split('.')[1].length;
    return 0;
  };
  NumberFormart(num: any): any {
    if (num == '' || num == null) {
      return 0;
    }
    if (parseFloat(num) <= 0) {
      if (this.countDecimals(num) > 5) {
        return parseFloat(num).toFixed(5);
      }
      return num;
    }
    if (parseFloat(num)) {
      if (this.countDecimals(num) > 5) {
        return parseFloat(num).toFixed(5);
      }
      return num;
    }
    return num;
  }
}
